export default {
	'main.openHistoryAndTodoDrawer': 'Открыть историю и задачи',
	'main.closeHistoryAndTodoDrawer': 'Закрыть историю и задачи',
};
